import { render, staticRenderFns } from "./AllInsolvencyPetitionSubmissions.vue?vue&type=template&id=38a2088e&scoped=true&"
import script from "./AllInsolvencyPetitionSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllInsolvencyPetitionSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllInsolvencyPetitionSubmissions.vue?vue&type=style&index=0&id=38a2088e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a2088e",
  null
  
)

export default component.exports